<div *ngIf="syncProgress$ | async" class="sync-progress-bar" [class.sync-complete]="(syncProgress$ | async)?.percent == 100">
	<div class="bar" [style.width.%]="(syncProgress$ | async)?.percent"></div>
	<div class="label">Live sync: <b>{{(syncProgress$ | async)?.percent}}%</b>, laps: <b>{{(syncProgress$ | async)?.lapsCount}}</b>, last at: <b>{{(syncProgress$ | async)?.lastLapTime.toDate() | date:'HH:mm:ss'}}</b></div>
</div>
